import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SnackBarType } from './snack-bar-message-type';
import { SnackBarMessageComponent } from './snack-bar-message.component';


@Injectable({
    providedIn: 'root'
})
export class SnackBarMessageService {

    constructor(private snackBar: MatSnackBar) { }

    public openSnackBar(message: string, snackType?: SnackBarType, duration?: number, verticalPosition?: MatSnackBarVerticalPosition, horizontalPosition?: MatSnackBarHorizontalPosition) {
        const _snackType: SnackBarType =
            snackType !== undefined ? snackType : SnackBarType.SUCCESS;

        this.snackBar.openFromComponent(SnackBarMessageComponent, {
            duration: duration ?? 10000,
            horizontalPosition: horizontalPosition ?? 'center',
            verticalPosition: verticalPosition ?? 'bottom',
            data: { message: message, snackType: _snackType }
        });
    }

    public closeSnackBar() {
        this.snackBar.dismiss();
    }
}
